
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.9 9.007c-.507-1.354-2.896-1.783-4.278-1.05-1.098.583-1.559 1.903-1.647 1.853-.09-.05.882-1.319.856-2.78-.028-1.48-1.09-3.253-2.812-3.833-1.993-.672-4.394.411-5.38 2.658-.654 2.032-.654 2.115-.244 4.766-1.647.476-2.799 1.796-2.261 4.013.947 2.204 4.04 3.168 6.186 2.135.059.368-.04 1.734-.04 1.734s-.201 2.253-.3 3.04a.412.412 0 00.236.422c.052.023.109.035.166.035l2.407-.018a.398.398 0 00.302-.144.408.408 0 00.09-.325c-.15-.98-.262-3.293-.171-4.871 1.456.119 3.7 1.948 4.873-.033.435-.734.221-2.039-.489-2.658-.655-.572-1.578-.423-1.59-.618-.012-.23 1.29-.209 2.385-.927 1.058-.695 2.15-2.229 1.712-3.4z","stroke":"currentColor","stroke-width":"2"}})])
          )
        }
      }
    